import { useState, useEffect, useRef } from "react";
import { RylzItem, RylzLabelItem } from "./rylzComponentMobileWeb";
import { VerticalVideoOverlayPlayer } from "../../verticalVideoOverlayPlayer/verticalVideoOverlayPlayer";
import { categoryObj } from "../../ynet1280/newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";
import { RylzMediaItem } from "../../verticalVideoOverlayPlayer/designs/rylzMediaItem/rylzMediaItem";
import { isWcmEditor } from "../../../../config/serverConfig";

interface RylzDisplayProps {
    items: RylzItem[]
    domain?: string
    isLTR?: boolean
    languageCode?: string
    category?: categoryObj
    tabTitleText?: string
    isTabVisible?: boolean;
    tabSubTitleText?: string;
    hideTabMoreButton?: boolean;
    tabBackgroundColor?: string;
}

export const RylzDisplay = (props: RylzDisplayProps) => {

    const { items, domain, isLTR, languageCode, category, tabTitleText, tabSubTitleText, tabBackgroundColor, isTabVisible, hideTabMoreButton } = props
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
    const [isPromoInView, setIsPromoInView] = useState(false);
    const containerRef = useRef(null) as any;
    const firstRylzItem = items[0]
    const lastRylzItems = items.slice(1, 5);
    const overlayItems = items.filter(item => item.siteItem);

    const getInitialPromoIndex = (): number => {
        const displayedItems = items.slice(0, 5);
        for (let i = 0; i < displayedItems.length; i++) {
            if (displayedItems[i] && displayedItems[i].videoDetails && displayedItems[i].videoDetails.promoPath) return i;
        }
        return -1;
    };

    const [currentPromoIndex, setCurrentPromoIndex] = useState(getInitialPromoIndex());

    const openFeed = () => {
        if (overlayItems.length > 0) {
            setSelectedVideoIndex(0);
            setIsOverlayOpen(true);
        }
    };

    useEffect(() => {
        if (isWcmEditor()) return;

        const observer = new IntersectionObserver(
            (entries) => {
                setIsPromoInView(entries[0].isIntersecting);
            },
            { threshold: 0.5 }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const onPromoVideoEnded = () => {
        const displayedItems = items.slice(0, 5);
        let nextIndex = -1;
        for (let i = currentPromoIndex + 1; i < displayedItems.length; i++) {
            if (displayedItems[i] && displayedItems[i].videoDetails && displayedItems[i].videoDetails.promoPath) {
                nextIndex = i;
                break;
            }
        }
        if (nextIndex === -1) {
            nextIndex = getInitialPromoIndex();
        }
        setCurrentPromoIndex(nextIndex);
    };

    const shouldDisplayPromo = (itemIndex: number) => {
        return !isWcmEditor() && isPromoInView && currentPromoIndex === itemIndex && items[itemIndex] && items[itemIndex].videoDetails && items[itemIndex].videoDetails.promoPath;
    };

    const handleItemClick = (item: RylzItem) => {
        if (!item.siteItem) return;
        const itemIndex = overlayItems.findIndex(v => v.id === item.id);
        if (itemIndex === -1) return;
        setSelectedVideoIndex(itemIndex);
        setIsOverlayOpen(true);
    }

    const handleOverlayClose = () => {
        setIsOverlayOpen(false);
    }

    const getItemLabel = (labelItem: RylzLabelItem, isSmallItem?: boolean) => {
        switch (labelItem.type) {
            case "text":
                return <div className="label-text" dangerouslySetInnerHTML={{ __html: labelItem.labelName }}></div>

            case "premium":
                return <div className="plus-icon icon"></div>;

            case "bepo":
                return <div className="bepo-icon icon"></div>;

            case "commentary":
                return (
                    <div className="commentary-label">
                        {labelItem.isDefaultYnetIcon ?
                            <div className="ynet-icon icon"></div>
                            :
                            <span className="author-image-wrapper">
                                <img className="author-image" src={labelItem.firstAuthorImage} alt={labelItem.author} />
                            </span>
                        }

                        {!isSmallItem && (
                            <div className="commentary-info">
                                <div className="title">פרשנות</div>
                                <div className="author">{labelItem.author}</div>
                            </div>
                        )}
                    </div>
                );

            case "logo":
                return labelItem.labelUrl ?
                    <img className="logo-image" src={labelItem.labelUrl} alt={labelItem.labelName} />
                    :
                    null;

            default:
                return null;
        }
    }

    return (
        <div className="rylz-component-mobile-web">
            {isTabVisible &&
                <div className="rylz-component-tab componentaTab" style={{ backgroundColor: tabBackgroundColor }}>
                    <div className="right-side-title">{tabTitleText}</div>

                    {!hideTabMoreButton &&
                        <div className="left-side-title" onClick={openFeed}>
                            <div className="title-text">{tabSubTitleText}</div>

                            <div className="arrow-icon"></div>
                        </div>
                    }
                </div>}

            <div className="latest-rylz-display" ref={containerRef}>
                <div className={`rylz-big-item ${shouldDisplayPromo(0) ? "promo-playing" : ""}`} onClick={() => handleItemClick(firstRylzItem)}>
                    {firstRylzItem.posterSrc && <img className="rylz-image" src={firstRylzItem.posterSrc} alt={firstRylzItem.title} />}

                    {shouldDisplayPromo(0) &&
                        <video
                            muted
                            autoPlay
                            playsInline
                            loop={false}
                            className="promoVideo"
                            onEnded={onPromoVideoEnded}
                            onError={onPromoVideoEnded}
                            poster={firstRylzItem.posterSrc}
                            src={firstRylzItem.videoDetails.promoPath}
                        />
                    }

                    <div className="item-content">
                        {firstRylzItem.labelItem && <div className="item-label">{getItemLabel(firstRylzItem.labelItem)}</div>}
                        <div className="item-title" dangerouslySetInnerHTML={{ __html: firstRylzItem.title }}></div>
                    </div>
                </div>

                <div className="latest-rylz-items">
                    {lastRylzItems.map((item, index) => {
                        const itemIndex = index + 1;
                        return (
                            <div className={`rylz-small-item ${shouldDisplayPromo(itemIndex) ? "promo-playing" : ""}`} key={index} onClick={() => handleItemClick(item)}>
                                {item.posterSrc && <img className="rylz-image" src={item.posterSrc} alt={item.title} />}

                                {shouldDisplayPromo(itemIndex) &&
                                    <video
                                        muted
                                        autoPlay
                                        playsInline
                                        loop={false}
                                        className="promoVideo"
                                        poster={item.posterSrc}
                                        onEnded={onPromoVideoEnded}
                                        onError={onPromoVideoEnded}
                                        src={item.videoDetails.promoPath}
                                    />
                                }

                                {item.labelItem && <div className="item-label">{getItemLabel(item.labelItem, true)}</div>}
                            </div>
                        );
                    })}
                </div>

                <VerticalVideoOverlayPlayer
                    isLTR={isLTR}
                    domain={domain}
                    isMobile={true}
                    category={category}
                    isTitleVisible={true}
                    showPrerollAds={false}
                    isSubTitleVisible={true}
                    languageCode={languageCode}
                    isOverlayOpen={isOverlayOpen}
                    selectedVideoIndex={selectedVideoIndex}
                    onVideoOverlayClose={handleOverlayClose}
                    videoItems={overlayItems.map(v => v.siteItem)}
                    ItemComponent={RylzMediaItem}
                />
            </div>
        </div>
    )
}

RylzDisplay.siteScriptName = "RylzDisplay";
